import { cn } from '@/utils';
import { BottomLabel, type BottomLabelProps } from './BottomLabel';
import { TopLabel, type TopLabelProps } from './TopLabel';
export const WithLabel = (props: Partial<TopLabelProps> & Partial<BottomLabelProps> & {
  className?: string;
  children: React.ReactNode;
  rightSlot?: React.ReactNode;
}) => {
  // 상단 accessory가 있는 조건
  const withTopAccessory = props.title || props.titleLeftSlot || props.titleRightSlot || props.description || props.optional || props.rightSlot;
  return <div className={cn('flex w-full flex-col gap-3xs', props.className)} data-sentry-component="WithLabel" data-sentry-source-file="WithLabel.tsx">
      {!!withTopAccessory && <div className="flex justify-between">
          <TopLabel title={props.title} titleLeftSlot={props.titleLeftSlot} titleRightSlot={props.titleRightSlot} optional={props.optional} description={props.description} />
          {props.rightSlot}
        </div>}
      {props.children}
      {props.helperText && <BottomLabel helperText={props.helperText} error={props.error} />}
    </div>;
};